module.exports = __webpack_public_path__ + "static/media/task6Planet1.dc6ed4f7.png";